// extracted by mini-css-extract-plugin
export default {"actions":"training-fields_actions__8bk6o"};